import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  Eligibility,
  NotEnrolledError,
  getWorkflowEligibility,
} from '@/services/workflow/qualification';

export const WORKFLOW_ELIGIBILITY_QUERY_KEY = 'workflow-eligibility';

export const useWorkflowEligibility = (
  orgId: string | undefined,
  workflowId: string | undefined,
  options?: Partial<UseQueryOptions<Eligibility, Error>>,
) =>
  useQuery<Eligibility, Error>({
    queryKey: [WORKFLOW_ELIGIBILITY_QUERY_KEY, orgId, workflowId],
    queryFn: async ({ signal }) => {
      if (!orgId || !workflowId) throw new Error('No org or workflow id');
      return getWorkflowEligibility(orgId, workflowId, signal);
    },
    enabled: !!orgId && !!workflowId,
    // Wave windows and check results move on their own, so a cached
    // verdict would grey a control that is now live.
    staleTime: 0,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) =>
      error instanceof NotEnrolledError ? false : failureCount < 2,
    ...options,
  });
